import { useQuery } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { leaderboardKeys } from '../leaderboard.keys';
import { checkSprintClaimsReviewed } from '../leaderboard.service';
export const useCheckSprintClaimsReviewed = (sprintId, subdomain = getSubdomain(), options) => {
    return useQuery({
        queryKey: leaderboardKeys.sprintClaimsReviewed(subdomain, sprintId),
        queryFn: () => checkSprintClaimsReviewed(subdomain, sprintId),
        enabled: !!sprintId,
        ...options,
    });
};
